import geocode from 'lib/location/geocode';
import GoogleGeocode from 'lib/location/Locations/Google';

export default class Prediction {
  googleData: google.maps.places.AutocompletePrediction;

  constructor(googleData: google.maps.places.AutocompletePrediction) {
    if (!googleData) {
      throw new Error('googleData is required');
    }
    this.googleData = googleData;
  }

  async toGeocode(): Promise<GoogleGeocode | undefined> {
    const googleGeocodeData = await geocode({
      placeId: this.googleData.place_id,
    });

    if (!googleGeocodeData) {
      return undefined;
    }

    return new GoogleGeocode(googleGeocodeData[0]);
  }

  get displayName(): string {
    const [city = '', state = '', zip = '', country = ''] = this.googleData.terms.map(
      (term) => term.value
    );
    return `${city}, ${state} ${zip}${country && `, ${country}`}`;
  }

  get valid(): boolean {
    // this is an approximation of ensuring that there is a city, state, possibly zip, and country
    return this.googleData.terms.length >= 3;
  }
}
